import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Typography, outlinedInputClasses } from '@mui/material';

import { EimInput } from '~/components/EimInput';
import { VehicleOptionsProvider, vehicleOptionsDefaultContext } from '~/contexts/VehicleOptionsContext';
import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';
import { IConfigurationRule } from '~/domain/IConfigurationRule';

import { RequestRedirect } from './RequestRedirect';

interface ISearchEimBody {
  eimPackSets: IConfigurationOptionGroup[];
  packSets: IConfigurationOptionGroup[];
  rules: IConfigurationRule[];
}

export const SearchEimBody = React.memo<ISearchEimBody>(function SearchEimPage(props) {
  const vehicleOptions = useState(vehicleOptionsDefaultContext);
  const location = useLocation();
  const { eim: initialEim = '', f: features } = location.state || {};
  const { eimPackSets, packSets, rules } = props;
  const invalidFeatures = !!features;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        height: '100%',
        alignItems: 'center',
        padding: '62px',
        gap: '18px',
      }}>
      <Typography>Please enter a valid and market specific EIM</Typography>
      <VehicleOptionsProvider value={vehicleOptions}>
        <RequestRedirect />
        <Box
          sx={{
            width: '550px',
            [`.${outlinedInputClasses.root}`]: {
              background: ({ palette }) => `${palette.background.paper} !important`,
            },
          }}
        >
          <EimInput
            eimPackSets={eimPackSets}
            packSets={packSets}
            rules={rules}
            defaultValue={initialEim}
            defaultErrorMessage={invalidFeatures ? 'Unable to load configuration provided in url' : ''}
          />
        </Box>
      </VehicleOptionsProvider>
    </Box>
  );
});
